import * as M from "@discovery/prelude/lib/data/maybe";
import { Input } from "../../../atoms/input";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import * as styles from "./styles.css";
import { isHTMLInputElement } from "../../../../utils/common";
const onBack = (id, event, handleInput, type) => {
    event && event.preventDefault();
    const target = event.target;
    if (isHTMLInputElement(target)) {
        if (event.keyCode === 8 || event.keyCode === 46) {
            const prevId = document.getElementById(id);
            prevId && prevId.focus();
            handleInput(event, type);
        }
    }
};
const autoFocusHandler = (id, event, handleInput, type) => {
    event && event.preventDefault();
    const target = event.target;
    if (isHTMLInputElement(target)) {
        const item = target.value;
        if (item.length === 1) {
            const isNumber = /^-?\d*$/.test(item);
            if (isNumber) {
                const nextId = document.getElementById(id);
                nextId && nextId.focus();
                handleInput(event, type);
            }
        }
    }
};
export const CustomPin = ({ label, handleInput, pin1, pin2, pin3, pin4, name, nextFocusID, autoFocus, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { classNameM: M.of(styles.yourPin), variant: HeaderVariants.headingSix, tag: Tags.h6 },
            React.createElement(React.Fragment, null, label)),
        React.createElement("div", { className: styles.textFieldWrapper, id: "otp-container" },
            React.createElement(Input, { maxLengthM: M.of(1), typeM: M.of("password"), classNameM: M.of(pin1.length > 0 ? styles.filled : styles.inputField), onInputChange: (e) => handleInput(e, `${name}1`), valM: M.of(pin1), name: `${name}1`, autofocus: autoFocus, onInput: (event) => autoFocusHandler(`${name}2`, event, handleInput, `${name}1`), idM: M.of(`${name}1`), onKeyUpM: (event) => onBack(`${name}1`, event, handleInput, `${name}2`) }),
            React.createElement(Input, { maxLengthM: M.of(1), typeM: M.of("password"), classNameM: M.of(pin2.length > 0 ? styles.filled : styles.inputField), onInputChange: (e) => handleInput(e, `${name}2`), valM: M.of(pin2), name: `${name}2`, onInput: (event) => autoFocusHandler(`${name}3`, event, handleInput, `${name}2`), idM: M.of(`${name}2`), onKeyUpM: (event) => onBack(`${name}1`, event, handleInput, `${name}2`) }),
            React.createElement(Input, { maxLengthM: M.of(1), typeM: M.of("password"), classNameM: M.of(pin3.length > 0 ? styles.filled : styles.inputField), onInputChange: (e) => handleInput(e, `${name}3`), valM: M.of(pin3), name: `${name}3`, idM: M.of(`${name}3`), onInput: (event) => autoFocusHandler(`${name}4`, event, handleInput, `${name}3`), onKeyUpM: (event) => onBack(`${name}2`, event, handleInput, `${name}2`) }),
            React.createElement(Input, { maxLengthM: M.of(1), typeM: M.of("password"), classNameM: M.of(pin4.length > 0 ? styles.filled : styles.inputField), onInputChange: (e) => handleInput(e, `${name}4`), valM: M.of(pin4), name: `${name}4`, idM: M.of(`${name}4`), onInput: (event) => autoFocusHandler(nextFocusID, event, handleInput, `${name}4`), onKeyUpM: (event) => {
                    if (event.keyCode === 8 || event.keyCode === 46) {
                        onBack(`${name}3`, event, handleInput, `${name}2`);
                    }
                } }))));
};

